import { Component, ElementRef, Inject, Input, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { SignupService } from '../services/signup.service';
import { SignupDataService } from '../services/signup-data.service';
import { ConnectSlideComponent } from '@app/blocks/ui/slide/slide.component';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { SlideCommonService } from '@app/application/common/slide-common.service';
import { WINDOW, WINDOW_PROVIDERS } from '@app/shared/services/window/window.service';
import * as _ from 'lodash';
import { FilterObjectsPipe } from '@app/shared/pipes/filter-objects.pipe';
import { DataService } from '@app/core/services/data.service';
import { Subject } from 'rxjs';
import { FormGroup, FormsModule } from '@angular/forms';

@Component({
    selector: 'app-payment-method',
    providers: [
        WINDOW_PROVIDERS
    ],
    imports: [
        CommonModule,
        FormsModule,
        ConnectSlideComponent,
        SpinnerComponent,
        FilterObjectsPipe,
        NgIf,
        NgFor
    ],
    templateUrl: './payment-method.component.html',
    styleUrl: './payment-method.component.scss'
})
export class PaymentMethodComponent implements OnDestroy {
    @Input() slideNumber: string | undefined;
    @Input() finalSlide = false;
    currentSlide = 'paymentMethod';
    referenceData = {};
    active: any = this.signupService.getActive();
    model: any = this.signupService.getPaymentMethodModel();
    errors: any = [];
    applicationId: any;
    help = [
        { id: 'directdebit', active: 'false' },
        { id: 'shortfallDirectdebit', active: 'false' },
        { id: 'online', active: 'false' },
        { id: 'shortfallOnline', active: 'false' },
        { id: 'benefits', active: 'false' }
    ];
    @ViewChild('paymentMethodForm') form?: FormGroup;

    private destroy$ = new Subject<void>();

    errorMessage: string = "";
    showFormErrors = false; //error summary
    showError = false;
    submitting = false;
    isDisabled = false;
    showSubmit = false;
    loading = true; // spinner
    subscription = this.signupService.subscribePaymentMethodModel((data: any) => {
        this.model = data;

        if (this.model.applicationForm && this.model.applicationForm != this.formState.applicationForm) {
            console.log("payment method setting application form to " + data.applicationForm);
            this.formState.applicationForm = data.applicationForm;
            this.signupService.setFormState(this.formState);
        }
        //the above if condition is not triggered due to applicationForm key not existing on nextOfKin response, so the check below has been added
        else {
            this.formState.applicationForm = this.signupService.getAdditionalDetailsModel().applicationForm;
        }

        this.logger.info('getPaymentMethod result', data);

        this.loading = false; // stop spinner
        this.showSubmit = true;
        this.showFormErrors = false;
    });

    constructor(
        private logger: LoggerService,
        private signupService: SignupService,
        private signupDataService: SignupDataService,
        private slideCommon: SlideCommonService,
        private dataService: DataService,
        private el: ElementRef,
        @Inject(WINDOW) private window: Window) {
        this.applicationId = sessionStorage.getItem('connect.applicationId'); // Adjust method call as per your service
    }

    get formState() {
        return this.signupService.formState;
    }


    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    scrollToId(id: string) {
        this.slideCommon.scrollToId(id, this.el, this.window);
    }

    onSubmit() {
        console.log(this.form)
        this.errors = [];

        this.checkSelected();

        if (this.errors.length === 0) {
            this.signupService.setPaymentMethodModel(this.model);

            this.isDisabled = true;
            this.loading = true;

            this.logger.info('signup submit > Payment Method Model', this.model);

            this.signupDataService.postPaymentMethod(this.model).subscribe({
                next: (response: any) => {
                    console.log(response);

                    this.formState.progress.paymentMethodComplete = true;
                    this.signupService.setFormState(this.formState);

                    this.signupService.goForward('paymentMethod');
                    this.slideCommon.scroll(this.active.active);

                    this.loading = false;
                    this.isDisabled = false;
                },
                error: (error) => {
                    this.logger.error('postPaymentMethod error', error.data);
                    this.loading = false;
                    this.showError = true;
                    this.errorMessage = "Error saving your payment method details, please contact support."
                    return null;
                }
            })

        } else {
            this.slideCommon.scroll('payment-method-error-summary');
        }

    }

    onBack() {
        this.loading = false;
        this.isDisabled = false;
        this.signupService.goBack('paymentMethod');
        this.slideCommon.scroll(this.active.active);
    }

    setActive(questionName: any, answer: any) {

        let applicationPaymentMethodQuestions: any = [];

        this.model?.applicationPaymentMethodQuestions?.forEach((q: any) => {
            if (q.name === questionName) {
                const answers: any = [];
                q.answers?.forEach((a: any) => {
                    if (a.id === answer.id) {
                        a.active = 'true';
                    } else {
                        a.active = 'false';
                    }
                    answers.push(a);
                });

                q.answers = answers;
            }
            applicationPaymentMethodQuestions.push(q);
        });

        applicationPaymentMethodQuestions = this.rules(applicationPaymentMethodQuestions);

        // update model
        this.model.applicationPaymentMethodQuestions = applicationPaymentMethodQuestions;
    }

    rules(applicationPaymentMethodQuestions: any) {
        this.logger.info("rules...");

        // rentPayment
        const rentPayment = _.find(applicationPaymentMethodQuestions, function (o: any) { return o.name === "cn_howwillyourrentbepaid"; });
        this.logger.info("rentPayment", rentPayment);

        const inFullByMyself = _.find(rentPayment.answers, function (o: any) { return o.id === "875970000"; });
        this.logger.info("inFullByMyself", inFullByMyself);

        const withAssistance = _.find(rentPayment.answers, function (o: any) { return o.id === "875970001"; });
        this.logger.info("withAssistance", withAssistance);

        // howPaying
        const howPaying = _.find(applicationPaymentMethodQuestions, function (o: any) { return o.name === "cn_howwillyoubepaying"; });

        const directDebit = _.find(howPaying.answers, function (o: any) { return o.id === "875970000"; });
        this.logger.info("directDebit", directDebit);

        const online = _.find(howPaying.answers, function (o: any) { return o.id === "875970001"; });
        this.logger.info("online", online);

        // receive
        const receive = _.find(applicationPaymentMethodQuestions, function (o: any) { return o.name === "cn_doyoucurrentlyreceive"; });

        const housingBenefit = _.find(receive.answers, function (o: any) { return o.id === "875970000"; });
        this.logger.info("housingBenefit", housingBenefit);

        const universalCredit = _.find(receive.answers, function (o: any) { return o.id === "875970001"; });
        this.logger.info("universalCredit", universalCredit);

        const newClaim = _.find(receive.answers, function (o: any) { return o.id === "875970002"; });
        this.logger.info("newClaim", newClaim);

        // rentContribution
        const rentContribution = _.find(applicationPaymentMethodQuestions, function (o: any) { return o.name === "cn_currentlymakecontributiontoyourrent"; });

        const noContribution = _.find(rentContribution.answers, function (o: any) { return o.id === "0"; });
        this.logger.info("noContribution", noContribution);

        const yesContribution = _.find(rentContribution.answers, function (o: any) { return o.id === "1"; });
        this.logger.info("yesContribution", yesContribution);

        // shortfall
        const shortfall = _.find(applicationPaymentMethodQuestions, function (o: any) { return o.name === "cn_howdoyouintendonpayinganyshortfall"; });

        const shortfallDirectDebit = _.find(shortfall.answers, function (o: any) { return o.id === "875970000"; });
        this.logger.info("shortfallDirectDebit", shortfallDirectDebit);

        const shortfallOnline = _.find(shortfall.answers, function (o: any) { return o.id === "875970001"; });
        this.logger.info("shortfallOnline", shortfallOnline);

        const iHowWillYourRentBePaid = _.findIndex(applicationPaymentMethodQuestions, function (o: any) { return o.name == 'cn_howwillyourrentbepaid'; });
        const iHowWillYouBePaying = _.findIndex(applicationPaymentMethodQuestions, function (o: any) { return o.name == 'cn_howwillyoubepaying'; });
        const iDoYouCurrentlyReceive = _.findIndex(applicationPaymentMethodQuestions, function (o: any) { return o.name == 'cn_doyoucurrentlyreceive'; });
        const iCurrentlyMakeContributionToYouRent = _.findIndex(applicationPaymentMethodQuestions, function (o: any) { return o.name == 'cn_currentlymakecontributiontoyourrent'; });
        const iHowDoYouIntendOnPayingAnyShortfall = _.findIndex(applicationPaymentMethodQuestions, function (o: any) { return o.name == 'cn_howdoyouintendonpayinganyshortfall'; });

        applicationPaymentMethodQuestions[ iHowWillYourRentBePaid ].active = "true";

        if (inFullByMyself.active === "true") {
            applicationPaymentMethodQuestions[ iHowWillYouBePaying ].active = "true";
        } else {
            applicationPaymentMethodQuestions[ iHowWillYouBePaying ].active = "false";

            const answers = this.resetActiveAnswers(applicationPaymentMethodQuestions, iHowWillYouBePaying);

            applicationPaymentMethodQuestions[ iHowWillYouBePaying ].answers = answers;
        }

        if (withAssistance.active === "true") {
            applicationPaymentMethodQuestions[ iDoYouCurrentlyReceive ].active = "true";
        } else {
            applicationPaymentMethodQuestions[ iDoYouCurrentlyReceive ].active = "false";

            const answers = this.resetActiveAnswers(applicationPaymentMethodQuestions, iDoYouCurrentlyReceive);

            applicationPaymentMethodQuestions[ iDoYouCurrentlyReceive ].answers = answers;
        }

        if (withAssistance.active === "true" && (housingBenefit.active === "true" || universalCredit.active === "true")) {
            this.logger.info('true');
            applicationPaymentMethodQuestions[ iCurrentlyMakeContributionToYouRent ].active = "true";
        } else {
            this.logger.info('false');
            applicationPaymentMethodQuestions[ iCurrentlyMakeContributionToYouRent ].active = "false";

            const answers = this.resetActiveAnswers(applicationPaymentMethodQuestions, iCurrentlyMakeContributionToYouRent);

            applicationPaymentMethodQuestions[ iCurrentlyMakeContributionToYouRent ].answers = answers;
        }

        if (withAssistance.active === "true" && (housingBenefit.active === "true" || universalCredit.active === "true") && yesContribution.active === "true") {
            applicationPaymentMethodQuestions[ iHowDoYouIntendOnPayingAnyShortfall ].active = "true";
        } else {
            applicationPaymentMethodQuestions[ iHowDoYouIntendOnPayingAnyShortfall ].active = "false";

            const answers = this.resetActiveAnswers(applicationPaymentMethodQuestions, iHowDoYouIntendOnPayingAnyShortfall);

            applicationPaymentMethodQuestions[ iHowDoYouIntendOnPayingAnyShortfall ].answers = answers;
        }

        // help text
        this.helpText(applicationPaymentMethodQuestions);

        return applicationPaymentMethodQuestions;
    }

    helpText(applicationPaymentMethodQuestions: any) {

        const howPaying = _.find(applicationPaymentMethodQuestions, function (o: any) { return o.name === "cn_howwillyoubepaying"; });
        const directDebit = _.find(howPaying.answers, function (o: any) { return o.id === "875970000"; });
        const online = _.find(howPaying.answers, function (o: any) { return o.id === "875970001"; });
        const shortfall = _.find(applicationPaymentMethodQuestions, function (o: any) { return o.name === "cn_howdoyouintendonpayinganyshortfall"; });
        const shortfallDirectDebit = _.find(shortfall.answers, function (o: any) { return o.id === "875970000"; });
        const shortfallOnline = _.find(shortfall.answers, function (o: any) { return o.id === "875970001"; });

        const ddHelpIndex = _.findIndex(this.help, function (o: any) { return o.id == 'directdebit'; });

        if (directDebit.active === "true") {
            this.help[ ddHelpIndex ].active = 'true';
        } else {
            this.help[ ddHelpIndex ].active = 'false';
        }

        const onHelpIndex = _.findIndex(this.help, function (o: any) { return o.id == 'online'; });

        if (online.active === "true") {
            this.help[ onHelpIndex ].active = 'true';
        } else {
            this.help[ onHelpIndex ].active = 'false';
        }

        const shortOnHelpIndex = _.findIndex(this.help, function (o: any) { return o.id == 'shortfallOnline'; });

        if (shortfallOnline.active === "true") {
            this.help[ shortOnHelpIndex ].active = 'true';
        } else {
            this.help[ shortOnHelpIndex ].active = 'false';
        }

        const shortDdHelpIndex = _.findIndex(this.help, function (o: any) { return o.id == 'shortfallDirectdebit'; });

        if (shortfallDirectDebit.active === "true") {
            this.help[ shortDdHelpIndex ].active = 'true';
        } else {
            this.help[ shortDdHelpIndex ].active = 'false';
        }
    }

    resetActiveAnswers(questions: any[], index: any) {
        const answers: any = [];

        questions[ index ].answers.forEach((a: any) => {
            const answer = a;
            answer.active = "false";
            answers.push(a);
        });

        // angular.forEach(questions[ index ].answers, function (a, key) {
        //     a.active = "false";
        //     this.push(a);
        // }, answers);

        return answers;
    }

    checkSelected() {
        this.logger.info('checkSelected called');

        this.model.applicationPaymentMethodQuestions.forEach((q: any) => {

            console.log(q);

            if (q.active === 'true') { // if question active, need to ensure we have 1 active answer
                let i = 0;

                q.answers.forEach((a: any) => {
                    if (a.active === 'true') {
                        i++;
                    }
                });

                if (i === 0) {
                    this.logger.info(q.name + ' need to select one option');

                    let errorTitle = "";
                    if (q.name === "cn_howwillyourrentbepaid") {
                        errorTitle = "How will your rent be paid";
                    }
                    if (q.name === "cn_howwillyoubepaying") {
                        errorTitle = "How will you pay";
                    }
                    if (q.name === "cn_doyoucurrentlyreceive") {
                        errorTitle = "Do you currently receive any of the following";
                    }
                    if (q.name === "cn_currentlymakecontributiontoyourrent") {
                        errorTitle = "Do you make a contribution to your rent";
                    }
                    if (q.name === "cn_howdoyouintendonpayinganyshortfall") {
                        errorTitle = "How do you intend to make your contribution";
                    }

                    this.errors.push({
                        'id': q.name,
                        'title': errorTitle,
                        'msg': 'please select one of the answers'
                    });
                } else {
                    this.logger.info(q.name + ' all good');
                }
            }
        });

        console.log(this.errors);
    }
}
